export const GRID_GAP_CN = 16
const MIN_CARD_WIDTH_CN = 180
const MAX_CARD_WIDTH_CN = 240

const getGridDimsCN = (numColumns: number) => ({
	minWidth: MIN_CARD_WIDTH_CN * numColumns + GRID_GAP_CN * (numColumns - 1),
	maxWidth: MAX_CARD_WIDTH_CN * numColumns + GRID_GAP_CN * (numColumns - 1),
})

export default getGridDimsCN
